import React, { useState, useContext } from 'react';
import './DatabaseBox.css'
import TextField from '@mui/material/TextField';
import InsertModal from './InsertModal';
import { useTranslation } from 'react-i18next'; // Importa o hook de tradução
import { AuthContext } from '../../../authContext';

function DatabaseBox({classeCSS, user, triggerUpdate, setFilters, setSelectedStatus,documentList, assistant, assistantId, sessionId}){

    const [isInsertModal, setIsInsertModal] = useState(false);
    const [status, setStatus] = useState('');
    const [searchTerm, setSearchTerm] = useState(''); // Filtro de nome local
    const [selectedDate, setSelectedDate] = useState(''); // Filtro de data local
    const [isReprocessingAll, setIsReprocessingAll] = useState(false);
    const { accessToken } = useContext(AuthContext);
    const { t: tDatabase } = useTranslation('database'), { t: tCommon } = useTranslation('common'); // Hook de tradução

    // Abre o modal de confirmação e define o documento a ser deletado
    const openInsertModal = () => {
        setIsInsertModal(true);
    };

    // Atualiza o filtro de busca ao digitar na barra de pesquisa
    const handleSearchChange = (e) => {
        const newSearchTerm = e.target.value;
        setSearchTerm(newSearchTerm);

        // Atualiza o estado global de filtros
        setFilters(prevFilters => ({
            ...prevFilters,
            searchTerm: newSearchTerm
        }));
    };

    // Atualiza o filtro de status ao selecionar uma opção
    const handleStatusChange = (e) => {
        const newStatus = e.target.value;
        setStatus(newStatus);

        // Atualiza o estado global de filtros
        setFilters(prevFilters => ({
            ...prevFilters,
            selectedStatus: newStatus
        }));
    };

    // Função para converter a data selecionada (YYYY-MM) para o formato MM/YYYY
    const convertToMonthYear = (dateString) => {
        const [year, month] = dateString.split('-'); // Divide a string 'YYYY-MM'
        return `${month}/${year}`; // Converte para 'MM/YYYY'
    };

    // Função que atualiza a data e aplica o filtro globalmente
    const handleDateChange = (e) => {
        const newDate = e.target.value ? convertToMonthYear(e.target.value) : '';
        setSelectedDate(newDate);
        setFilters(prevFilters => ({
            ...prevFilters,
            selectedDate: newDate
        }));
    };

    const handleReprocessAll = async () => {
        if (assistantId !== '3' || isReprocessingAll) {
            return;
        }
        setIsReprocessingAll(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/post_reprocess_site_documents`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ session_id: sessionId })
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.error || tDatabase('reprocess_documents_error'));
            }
            triggerUpdate();
            setTimeout(() => triggerUpdate(), 4000);
            const total = data?.result?.reprocessed_files?.length ?? 0;
            alert(total > 0 ? tDatabase('reprocess_started_total', { count: total }) : tDatabase('reprocess_none'));
        } catch (error) {
            console.error('Erro ao reprocessar documentos:', error);
            alert(error.message || tDatabase('reprocess_documents_error'));
        } finally {
            setIsReprocessingAll(false);
        }
    };

    return(
        <div className={classeCSS}>

            <InsertModal
            isOpen={isInsertModal}
            onClose={() => setIsInsertModal(false)}
            user={user} // Passa o usuário para uso na função de insert
            triggerUpdate={triggerUpdate}
            assistant={assistant}
            assistantId={assistantId}
            sessionId={sessionId}
            documentList={documentList}
            />
            
            <div className='comandos'>
                
                <button 
                className='add-button'
                onClick={() => openInsertModal()}
                > 
                    <img src="/imagens/add.svg" alt={tDatabase('addIcon')} />
                    {tCommon('new')}
                </button>

                {assistantId === '3' && (
                    <button
                        className='reprocess-button'
                        onClick={handleReprocessAll}
                        disabled={isReprocessingAll}
                    >
                        {isReprocessingAll ? tDatabase('reprocessing_all') : tDatabase('reprocess_all')}
                    </button>
                )}

                <div className='search-bar'>
                    <img src="/imagens/lupa.svg" alt={tDatabase('searchIcon')} />
                    <TextField
                    variant="outlined"
                    placeholder={tDatabase('search_name')}
                    fullWidth
                    className='search-input'
                    autoComplete="off" // Desativa o preenchimento automático do navegador
                    value={searchTerm}
                    onChange={handleSearchChange}
                    InputProps={{
                        style: { height: '1.875rem' }, // Define a altura diretamente
                    }}
                    />
                </div>

                <div className='status-bar'>
                    <select 
                    className="status-search"
                    value={status} 
                    onChange={handleStatusChange}
                    >
                        <option value="" hidden>{tDatabase('status')}</option>
                        <option value="Official">{tDatabase('official')}</option>
                        <option value="Draft">{tDatabase('draft')}</option>
                        <option value="Todos">{tCommon('all')}</option>
                    </select>
                </div>

                <div className='data-bar'>
                    <input 
                        type="month" 
                        id="data-input" 
                        className="date-search"
                        onChange={handleDateChange}
                    />
                    <div 
                    className="selected-date-display"
                    >
                        {selectedDate ? selectedDate : tDatabase('monthYearPlaceholder')} {/* Exibe a data selecionada ou o placeholder */}
                    </div>
                </div>

            </div>
            
        </div>
    )
}

export default DatabaseBox
